// [PROSPEK] 2026-03-24 Pipeline board routes
import { frontendURL } from 'dashboard/helper/URLHelper';

const KanbanPageRouteView = () =>
  import('../kanban/pages/KanbanPageRouteView.vue');
const KanbanBoard = () => import('../kanban/pages/KanbanBoard.vue');

const PIPELINE_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/pipeline'),
      component: KanbanPageRouteView,
      meta: { permissions: PIPELINE_PERMISSIONS },
      children: [
        {
          path: '',
          name: 'pipeline_board',
          meta: { permissions: PIPELINE_PERMISSIONS },
          component: KanbanBoard,
        },
        {
          path: 'conversations/:conversation_id',
          name: 'pipeline_board_conversation',
          meta: { permissions: PIPELINE_PERMISSIONS },
          component: KanbanBoard,
          props: route => ({ conversationId: route.params.conversation_id }),
        },
      ],
    },
  ],
};
// [/PROSPEK]
